'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component", "color", "children", "buttonSize", "size", "iconOnly", "iconLeading", "iconTrailing", "aria-label", "aria-labelledby", "aria-hidden"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { EncoreContext, encoreContextKeyword, getStatus } from "../../contexts/EncoreContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { buttonSizesWithDeprecationWarning, controlIconSize, getNextControlSize } from "../../styles/index.mjs";
import { Button } from "./Button.mjs";
import { ButtonChildren } from "./ButtonChildren.mjs";
import { warn } from "../../logging.mjs";
export var ButtonComponent = /*#__PURE__*/React.forwardRef(function ButtonComponent(_ref, ref) {
  var component = _ref.component,
    color = _ref.color,
    children = _ref.children,
    buttonSize = _ref.buttonSize,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    iconOnly = _ref.iconOnly,
    iconLeading = _ref.iconLeading,
    iconTrailing = _ref.iconTrailing,
    ariaLabel = _ref['aria-label'],
    ariaLabelledby = _ref['aria-labelledby'],
    ariaHidden = _ref['aria-hidden'],
    props = _objectWithoutProperties(_ref, _excluded);
  if (iconOnly && !ariaLabel && !ariaLabelledby && !ariaHidden) {
    warn('ButtonTertiary must have an aria-label or aria-labelledby attribute defined when using the iconOnly prop in order to be accessible.');
  }
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.button, config);
  var rel = props.href && props.target === '_blank' ? 'noopener noreferrer' : null;

  // TODO: Remove this once buttonSize is archived, and use size instead
  var localSize = buttonSize ? getNextControlSize(buttonSize) : size;
  /** Override standard icon size for lg iconOnly buttons */
  var iconSize = iconOnly && localSize === 'large' ? 'large' : controlIconSize[localSize];
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, props, {
    rel: rel,
    ref: ref,
    component: !component && props.href ? 'a' : component,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-hidden": ariaHidden,
    buttonSize: localSize,
    iconSize: iconSize,
    iconLeading: iconLeading,
    iconTrailing: iconTrailing,
    iconOnly: iconOnly,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    status: status,
    "data-encore-id": ENCORE_DATA_IDS.ButtonTertiary
  }), /*#__PURE__*/React.createElement(ButtonChildren, {
    iconOnly: iconOnly,
    iconLeading: iconLeading,
    iconTrailing: iconTrailing,
    iconSize: iconSize,
    children: children,
    buttonSize: localSize
  }));
});

/**
 * TODO: Remove when we deprecate `buttonSize` helpers like `ButtonTertiary.sm`.
 */
var buttonHelpers = _objectSpread(_objectSpread({}, buttonSizesWithDeprecationWarning), {}, {
  displayName: 'ButtonTertiary'
});
export var ButtonTertiary = Object.assign(ButtonComponent, buttonHelpers);